import React = require("react")
import { Library } from ".."
import newsletterBlock from "../bkw/newsLetterForm"
import footerTop from "./footerTop"
import homeJumbo from "./homeJumbo"
import menuLink from "./menuLink"

const searchPlaceholderImage = {
  src: '/bkw/images/bkw/logo.svg',
  alt: 'Logo Bibliotheek Twente',
  width: "165",
  height: "60"
}

export const primaryColor = '#FF7320';

const whiteLabel: Library = {
  logo: () => <img width="231" height="83" src="/bkw/images/bkw/logo.svg" alt="Bibliotheek Kennemerwaard" aria-hidden="true" />,
  primaryColor,
  menuLink,
  homeJumbo,
  footerTop,
  newsletterBlock,
  searchPlaceholderImage,
  collectionSearchUrl: term => `https://probiblio.hostedwise.nl/wise-apps/opac/6530/catalog/search?qs=${term}`,
  loginUrl: "https://probiblio.hostedwise.nl/cgi-bin/bx.pl?var=portal;prt=INTERNET;taal=nl_NL;event=private;vestnr=6530",
  features: {
    autoHyphenate: true,
    manualHyphenate: true
  },
  notFoundPath: '/404',
  copy: {
    forms: {
      loadingFailed: 'Het formulier kon helaas niet geladen worden. Herlaad de pagina of neem contact op met Bibliotheek Kennemerwaard.'
    },
    vacancies: {
      noVacanciesFound:
        `Op dit moment zijn er helaas geen vacatures beschikbaar. Maar dat wil niet zeggen dat jij
        niets voor de bibliotheek kunt betekenen. Stuur ons dus vooral jouw contactgegevens en cv.
        Wellicht hebben we binnenkort wél een geschikte vacature!`
    }
  }
}

export default whiteLabel;